import { MenuDataItem } from "../../../types";
import { Icon } from "../Icon";

interface CategoryMenuItemProps {
  items: MenuDataItem[];
  updateMenu: (item: MenuDataItem) => void;
}

export const CategoryMenuItems = ({
  items,
  updateMenu,
}: CategoryMenuItemProps) => {
  const withChildren = (item: MenuDataItem) => (
    <li>
      <button
        onClick={() => updateMenu(item)}
        class="side-menu-item has-children"
      >
        <span>{item.link.text}</span>
        <Icon name="chevron-right" />
      </button>
    </li>
  );

  const withoutChildren = (item: MenuDataItem) => (
    <li>
      <a href={item.link.href} class="side-menu-item">
        {item.link.text}
      </a>
    </li>
  );

  return (
    <>
      {items && items.length > 0 && (
        <ul class="menu-list">
          {items.map((item) => {
            if (item.items && item.items.length > 0) {
              return withChildren(item);
            } else {
              return withoutChildren(item);
            }
          })}
        </ul>
      )}
    </>
  );
};
